import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, MenuItem } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import useTenant from "../../../hooks/useTenant";
import SearchableAutoComplete from "../../../components/SearchableAutoComplete";
import FilterReset from "../../../components/FilterReset";
import { searchPayload, convertedValue, formatDate } from "../../../utils/common";
import ReactHookFormSelect from "../../../components/ReactHookFormSelect";
import CustomTextField from "../../../components/CustomTextField";
import { useDialog } from "../../../contexts/DialogContext";
import usePlan from "../../../hooks/usePlan";
import CustomDatePicker from "../../../components/CustomDatePicker";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

function AdvanceFilter(props) {
  const { unSetDialog } = useDialog();
  const today = formatDate(new Date());

  const initialValues = {
    userName: "",
    tenantName: {},
    planName: {},

    invoiceDateStr: `${today} 00:00:00,${today} 23:59:59`,
    invoiceDate: [new Date(), new Date()],
  };

  const { fields, payload, setPayload, setFilterResetFunc, filterFormData, setFilterFormData } =
    props;

  const { autoSearchTenant, tenantAutoSearchResults } = useTenant();
  const { autoSearchPlan, planAutoSearchResults, isLoadingAutoSearch } = usePlan();

  const [planPayload, setPlanPayload] = useState(currentPayload);
  const [planOptions, setPlanOptions] = useState([]);
  const [tenantPayload, setTenantPayload] = useState(currentPayload);
  const [tenantOptions, setTenantOptions] = useState([]);

  const [defaultTenant, setDefaultTenant] = useState({});
  const [defaultPlan, setDefaultPlan] = useState({});

  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: filterFormData || initialValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = methods;

  useEffect(() => {
    setFilterResetFunc(() => () => reset(initialValues));
  }, [reset]);

  const onSubmit = async (data) => {
    try {
      setFilterFormData(data);
      let filters = [];
      if (data.userName != null && Object.keys(data.userName).length != 0) {
        filters.push({
          fieldName: "userName",
          fieldValue: data.userName,
          op: "like",
          dataType: "string",
          condition: "and",
          isJoin: true,
          entityName: "RadUserEntity",
          attributeName: "radUser",
        });
      }
      if (data.planName != null && Object.keys(data.planName).length != 0) {
        filters.push({
          fieldName: "planId",
          fieldValue: convertedValue(data.planName, "value").join(","),
          op: "eq",
          dataType: "int",
          condition: "and",
          isJoin: true,
          entityName: "PlanEntity",
          attributeName: "plan",
        });
      }
      if (data.tenantName != null && Object.keys(data.tenantName).length != 0) {
        filters.push({
          fieldName: "tenantId",
          fieldValue: convertedValue(data.tenantName, "value").join(","),
          op: "eq",
          dataType: "int",
          condition: "and",
          isJoin: true,
          entityName: "TenantEntity",
          attributeName: "tenant",
        });
      }
      if (data.invoiceDate != "" && data.invoiceDate != null) {
        console.log(data.invoiceDateStr, "data.invoiceDateStr");
        filters.push({
          fieldName: "invoiceDate",
          fieldValue: data.invoiceDateStr,
          op: "btn",
          dataType: "date",
          condition: "and",
          isJoin: false,
        });
      }
      setPayload({
        ...payload,
        filters: filters,
      });
      unSetDialog("advance_filter");
    } catch (err) {
      console.error(err, "errerrerrerr");
    }
  };

  const fetchTenant = async () => {
    await autoSearchTenant(tenantPayload);
  };
  useEffect(() => {
    fetchTenant();
  }, [tenantPayload]);

  useEffect(() => {
    if (tenantAutoSearchResults.data.length !== 0) {
      setTenantOptions([...tenantOptions, ...tenantAutoSearchResults.data]);
    }
  }, [tenantAutoSearchResults]);

  const fetchPlan = async () => {
    await autoSearchPlan(planPayload);
  };
  useEffect(() => {
    fetchPlan();
  }, [planPayload]);

  useEffect(() => {
    if (planAutoSearchResults.data.length !== 0) {
      setPlanOptions([...planOptions, ...planAutoSearchResults.data]);
    }
  }, [planAutoSearchResults]);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2} pt={8}>
            <Grid item md={6} sm={6} xs={8}>
              <CustomTextField
                label={t("user_name")}
                name="userName"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>
            <Grid item md={6} sm={6} xs={8}>
              <SearchableAutoComplete
                control={control}
                data={tenantOptions}
                label="Franchise Name"
                payload={tenantPayload}
                setPayload={setTenantPayload}
                loading={isLoadingAutoSearch}
                name="tenantName"
                multiple={false}
                defaultValue={defaultTenant}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} pt={8}>
            <Grid item md={6} sm={8} xs={12}>
              <CustomDatePicker
                name="invoiceDate"
                nameTemp="invoiceDateStr"
                label="Invoice Date"
                range={true}
                control={control}
              />
            </Grid>
          </Grid>
          <FilterReset resetForm={() => reset(initialValues)} />
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default AdvanceFilter;
